import React from "react";
import { PageWrapper } from "@components/PageWrapper";
import { useIntl } from "react-intl";

export const DashboardPage = () => {
    const intl = useIntl();

    return <PageWrapper title={intl.formatMessage({ id: "pages.dashboard.title" })}></PageWrapper>;
};
